<template>
  <div class="bg">
    <!-- <span class="title">
      请前往电脑端进行登录
    </span> -->
  </div>
</template>

<script>
export default {
  name: 'Error',
  mounted () {
    // window.addEventListener('resize', this.forceLandscapeScreenHandle.bind(this))
    // this.forceLandscapeScreenHandle()
  },
  methods: {
    forceLandscapeScreenHandle () {
      const body = document.getElementsByTagName('body')[0]
      const html = document.getElementsByTagName('html')[0]
      body.style.width = html.clientWidth + 'px'
      body.style.height = html.clientHeight + 'px'
    }
  }
}
</script>
<!-- <style lang="scss">
@media screen and (orientation: portrait) {
  /*竖屏样式*/
  body {
    transform-origin: unset;
    transform: unset;
  }
}
</style> -->
<style scoped lang="scss">
.bg {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/phone.png') center no-repeat;
  background-size: cover;
  .title{
    display: inline-block;
    position: relative;
    background: rgba($color: #FFFFFF, $alpha: 0.1);
    border-radius: 12px;
    top: 40%;
    font-size: 20PX;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #B8EAFF;
    padding: 120px 240px;
    backdrop-filter: blur(10px);
  }
}
</style>
